export function focusHomeReply(editor, selectionStart, selectionEnd) {
  if (!editor || !['/home', '/timelines/home'].includes(window.location.pathname)) return false;
  window.scrollTo({ top: 0, behavior: 'instant' });
  editor.setSelectionRange(selectionStart, selectionEnd);
  editor.focus({ preventScroll: true });

  // A long reply preview may put the editor below the viewport even at the top.
  const top = editor.getBoundingClientRect().top;
  const headerBottom = document.querySelector('.dr-topbar')?.getBoundingClientRect().bottom ?? 0;
  if (top < headerBottom || top > window.innerHeight - 80) {
    window.scrollTo({ top: Math.max(0, window.scrollY + top - headerBottom - 16), behavior: 'instant' });
  }
  return true;
}
